import { Outlet, useLocation } from 'react-router-dom'

import { paths } from 'src/config/paths'
import EnterpriseFooter from 'src/shared/features/enterprise/components/footer'
import ProfessionalHeader from 'src/shared/features/enterprise/components/professional-header'
import {
  ProfessionalFooterProvider,
  useProfessionalFooterContext,
} from 'src/shared/features/enterprise/context/professional-footer-context'
import { ProfessionalHeaderProvider } from 'src/shared/features/enterprise/context/professional-header-context'
import { cn } from 'src/shared/utils/cn'

function ProfessionalPublicLayoutContent() {
  const location = useLocation()
  const isProfessionalHomePage = location.pathname === paths.professionals.index.getHref()
  const { isFloatingStartJourneyButtonVisible } = useProfessionalFooterContext()

  return (
    <div className={cn('min-h-dvh', !isProfessionalHomePage && 'pt-[55px] xs:pt-[70px]')}>
      <ProfessionalHeader className={cn(!isProfessionalHomePage && 'bg-white')} />
      <Outlet />
      <EnterpriseFooter
        className={cn(isFloatingStartJourneyButtonVisible && 'pb-[100px] xs:pb-[110px] md:pb-[90px]')}
      />
    </div>
  )
}

export default function ProfessionalPublicLayout() {
  return (
    <ProfessionalHeaderProvider>
      <ProfessionalFooterProvider>
        <ProfessionalPublicLayoutContent />
      </ProfessionalFooterProvider>
    </ProfessionalHeaderProvider>
  )
}
